import React, { useEffect, useMemo, useState } from "react";
import "../assets/Loan/LoanCloserReport.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileCsv,
  faFileExcel,
  faPrint,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { useDispatch, useSelector } from "react-redux";

const LoanCloserReport = () => {
   const dispatch = useDispatch();
  const navigate = useNavigate();
    const { profile } = useSelector((state) => state.userProfile);
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
      const [company, setCompany] = useState(null);

  const [filters, setFilters] = useState({
    loanAccountNumber: "",
    customerName: "",
    customerId: "",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

    const formatDateDDMMYY = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = String(d.getFullYear());
  return `${dd}/${mm}/${yy}`;
};

          useEffect(() => {
        dispatch(fetchUserProfile());
      }, [dispatch]);

  const handleChange = (e) => {
    const value = Number(e.target.value);
    setItemsPerPage(value);
    console.log("Items per page:", value); // optional: send to parent or API
  };
  
  
    useEffect(()=>{
        const fetchCompany = async () => {
        try {
          const res = await fetch(
            `https://narrowitsolution.in/api/get-company?superAdminId=${profile?.superAdminId}`
          );
          const data = await res.json();
          if (res.ok && data) {
            if (data.logo)
              data.logoUrl = `https://narrowitsolution.in/${data.logo.replace(/^images\//, "")}`;
            setCompany(data);
          }
        } catch (err) {
          console.error("Failed to fetch company details", err);
        }
      };
      fetchCompany();
    },[profile?.superAdminId])

  // ============================
  // FETCH ONLY CLOSED LOANS
  // ============================
  const fetchClosedLoans = async () => {
    try {
      setLoading(true);
      setError(null);

      const userId = localStorage.getItem("userId");

      const res = await axios.get("https://narrowitsolution.in/api/get-all-loan-sgd", {
        params: {
          userId,
          status: ["closed", "requested"],
        },
      });

      // console.log("loan response", res.data);

      const rawData = Array.isArray(res.data?.data)
        ? res.data.data
        : Array.isArray(res.data?.loans)
          ? res.data.loans
          : Array.isArray(res.data)
            ? res.data
            : [];

      // ✅ CLOSED + CLOSE REQUESTED
      const filteredLoans = rawData.filter((loan) =>
        ["closed", "requested"].includes(loan.status?.toLowerCase()),
      );

      console.log("Filtered Loans:", filteredLoans);
      setLoans(filteredLoans);
    } catch (err) {
      setError("Failed to fetch loan data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClosedLoans();
  }, []);

  // ============================
  // FILTER LOGIC
  // ============================
  const filteredLoans = useMemo(() => {
    return loans.filter((loan) => {
      const { loanAccountNumber, customerName, customerId } = filters;

      const matchAccount =
        !loanAccountNumber ||
        loan.loanAccountNumber
          ?.toLowerCase()
          .includes(loanAccountNumber.toLowerCase());

      const matchName =
        !customerName ||
        loan.userName?.toLowerCase().includes(customerName.toLowerCase());

      const matchCustomerId =
        !customerId ||
        loan.customerId?.toLowerCase().includes(customerId.toLowerCase());

      return matchAccount && matchName && matchCustomerId;
    });
  }, [loans, filters]);

  // ============================
  // PAGINATION
  // ============================
  const totalItems = filteredLoans.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedLoans = filteredLoans.slice(
    startIndex,
    startIndex + itemsPerPage,
  );

  // ============================
  // EXPORTS
  // ============================
  const exportExcel = () => {
    const data = paginatedLoans.map((loan) => ({
      "Account Number": loan.loanAccountNumber,
      "Customer Id": loan.customerId,
      "Customer Name": loan.userName,
      "Loan Amount": loan.loanAmount,
      "Date":`${formatDateDDMMYY(loan.closedAt)}`,
      "Remark": loan.closureRemark,
      "Loan Status": loan.status,
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    
      // 🔹 Header styling
      const headerCells = Object.keys(data[0]);
      headerCells.forEach((_, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
        ws[cellRef].s = {
          font: {
            bold: true,
            color: { rgb: "FFFFFF" },
          },
          fill: {
            fgColor: { rgb: "1F4E78" }, // dark blue
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        };
      });
    
      // 🔹 Auto column width
      ws["!cols"] = headerCells.map((key) => ({
        wch: Math.max(key.length + 5, 18),
      }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Closed Loans");
    XLSX.writeFile(wb, "ClosedLoanReport.xlsx");
  };


const exportCSV = () => {
  const data = paginatedLoans.map((loan) => ({
    "Account Number": loan.loanAccountNumber ?? "",
    "Customer Id": loan.customerId ?? "",
    "Customer Name": loan.userName ?? "",
    "Loan Amount": loan.loanAmount ?? "",
    "Date": `'${formatDateDDMMYY(loan.closedAt)}`,
    "Remark": loan.closureRemark ?? "",
    "Loan Status": loan.status ?? "",
  }));

  const ws = XLSX.utils.json_to_sheet(data);
  const csv = XLSX.utils.sheet_to_csv(ws);

  const blob = new Blob([csv], {
    type: "text/csv;charset=utf-8;",
  });

  saveAs(blob, "ClosedLoanReport.csv");
};


  const exportPDF = async() => {
        const doc = new jsPDF("p", "mm", "a4");
          const pageWidth = doc.internal.pageSize.width;
          const pageHeight = doc.internal.pageSize.height;
    
            // ================= LOGO =================
    const logoX = 15;
    const logoY = 12;
    const logoSize = 25;
    const logoPadding = 2;
    
    // Border color & thickness
    doc.setDrawColor(0);
    doc.setLineWidth(0.2);
    
    // Calculate center of logo
    const centerX = logoX + logoSize / 2;
    const centerY = logoY + logoSize / 2;
    
    // Radius = half of logo + padding
    const radius = logoSize / 2 + logoPadding;
    
    // Draw circle
    doc.circle(centerX, centerY, radius);
    
    
    // Logo image
    if (company?.logoUrl) {
      try {
        const logoResp = await fetch(company.logoUrl);
        const logoBlob = await logoResp.blob();
        const reader = new FileReader();
        await new Promise((resolve) => {
          reader.onload = () => {
            doc.addImage(reader.result, "PNG", logoX, logoY, logoSize, logoSize);
            resolve();
          };
          reader.readAsDataURL(logoBlob);
        });
      } catch {
        // silent fail
      }
    }
    
      // ================= COMPANY NAME (AUTO WRAP) =================
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
    
      const nameX = logoX + logoSize + 5;
      const nameY = 18;
      const nameMaxWidth = pageWidth - nameX - 15;
    
      const companyNameText = doc.splitTextToSize(
        (company?.name || "COMPANY NAME").toUpperCase(),
        nameMaxWidth
      );
    
      doc.text(companyNameText, nameX, nameY);
    
      // Calculate Y after company name
      let currentY = nameY + companyNameText.length * 6;
    
      // ================= COMPANY DETAILS =================
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
    
      const detailX = nameX;
      const detailMaxWidth = nameMaxWidth;
    
      // Address
      const addressText = doc.splitTextToSize(
        company?.address || "Company Address",
        detailMaxWidth
      );
      doc.text(addressText, detailX, currentY);
      currentY += addressText.length * 5;
    
      // Email
      const emailText = doc.splitTextToSize(
        `Email: ${company?.email || "-"}`,
        detailMaxWidth
      );
      doc.text(emailText, detailX, currentY);
      currentY += emailText.length * 5;
    
      // Phone
      const phoneText = doc.splitTextToSize(
        `Phone: ${company?.contact || "-"}`,
        detailMaxWidth
      );
      doc.text(phoneText, detailX, currentY);
      currentY += phoneText.length * 5;
    
      // Divider
      doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);
    
      // ================= REPORT TITLE =================
      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.text(
        "Closed Loan Report",
        pageWidth / 2,
        currentY + 14,
        { align: "center" }
      );


      const tableColumn = [
       "SN",
          "Account Number",
          "Customer Id",
          "Customer Name",
          "Loan Amount",
          "Date",
          "Remark",
          "Status",
    ];
    const tableRows = [];

       paginatedLoans.forEach((l, i) => {
      const loanData = [
       i + 1,
        l.loanAccountNumber,
        l.customerId,
        l.userName,
        l.loanAmount,
        new Date(l.closedAt).toLocaleDateString("en-GB"),
        l.closureRemark,
        l.status,
      ];
      tableRows.push(loanData);
    });
    
     autoTable(doc, {
          head: [tableColumn],
          body: tableRows,
          startY:currentY+ 20,
           theme: "grid",
      styles: {
        fontSize: 7,
        cellPadding: 3,
        halign: "center",
      },
      headStyles: {
        fontStyle: "bold",
        fontSize: 7,
      },
      footStyles: {
        fillColor: [220, 220, 220],
        textColor: 20,
        fontStyle: "bold",
        fontSize: 8,
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
        });
    doc.save("ClosedLoanReport.pdf");
  };

  // ============================
  // JSX
  // ============================
  return (
    <div className="loanCloserReport-container">
      {/* FILTER */}
      <section className="loanCloserReport-filter">
        <h2 className="loanCloserReport-filter-title">
          Loan Closer Report Filter
        </h2>

        <form
          className="loanCloserReport-form"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="loanCloserReport-form-group">
            <label>Loan Account Number</label>
            <input
              name="loanAccountNumber"
              value={filters.loanAccountNumber}
              placeholder="Loan Account Number"
              onChange={(e) =>
                setFilters({ ...filters, loanAccountNumber: e.target.value })
              }
            />
          </div>

          <div className="loanCloserReport-form-group">
            <label>Customer Name</label>
            <input
              name="customerName"
              value={filters.customerName}
              placeholder="Customer Name"
              onChange={(e) =>
                setFilters({ ...filters, customerName: e.target.value })
              }
            />
          </div>

          <div className="loanCloserReport-form-group">
            <label>Customer Id</label>
            <input
              name="customerId"
              value={filters.customerId}
              placeholder="Customer Id"
              onChange={(e) =>
                setFilters({ ...filters, customerId: e.target.value })
              }
            />
          </div>
        </form>
      </section>

      {/* TABLE */}
      <section className="loanCloserReport-details">
        <div className="loanCloserReport-header">
          <h2 className="loanCloserReport-details-title">
            Closed Loan Details
          </h2>

          <div className="BranchLoanReport-items-per-page">
            <label htmlFor="itemsPerPage">Items per page:</label>
            <select
              id="itemsPerPage"
              value={itemsPerPage}
              onChange={handleChange}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={50000}>All</option>
            </select>
          </div>

          <div className="loanCloserReport-header-actions">
            <button onClick={exportCSV} className="loanCloserReport-btn-csv">
              <FontAwesomeIcon icon={faFileCsv} /> CSV
            </button>
            <button
              onClick={exportExcel}
              className="loanCloserReport-btn-excel"
            >
              <FontAwesomeIcon icon={faFileExcel} /> Excel
            </button>
            <button onClick={exportPDF} className="loanCloserReport-btn-print">
              <FontAwesomeIcon icon={faPrint} /> PDF
            </button>
          </div>
        </div>

        <div className="loanCloserReport-table-wrapper">
          <table className="loanCloserReport-table">
            <thead>
              <tr>
                <th>
                  SN <FontAwesomeIcon icon={faSortUp} />
                </th>
                <th>Account Number</th>
                <th>Customer Id</th>
                <th>Customer Name</th>
                <th>Loan Amount</th>
                <th>Date</th>
                <th>Remark</th>
                <th>Loan Status</th>
                <th>NOC Letter</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="9">Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="9">{error}</td>
                </tr>
              ) : paginatedLoans.length ? (
                paginatedLoans.map((loan, i) => (
                  <tr key={i}>
                    <td>{startIndex + i + 1}</td>
                    <td>{loan.loanAccountNumber}</td>
                    <td>{loan.customerId}</td>
                    <td>{loan.userName}</td>
                    <td>₹{loan.loanAmount}</td>
                    <td>
                      {loan.closedAt
                        ? new Date(loan.closedAt).toLocaleDateString("en-GB").replaceAll('/','-')
                        : "--"}
                    </td>
                    <td>{loan.closureRemark||"--"}</td>
                    <td>
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          {loan.status}
                        </span>
                    </td>
                    {/* <td>
                      {loan.status === "closed" && (
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          {loan.status}
                        </span>
                      )}
                      {loan.status === "requested" && (
                        <span style={{ color: "orange", fontWeight: "bold" }}>
                          {loan.status}
                        </span>
                      )}
                    </td> */}
                    {/* <td className="status-closed">{loan.status}</td> */}
                    <td>
                      {loan.status === "closed" && (
                        <div className="noc-letter-view">
                        <button
                          onClick={() =>
                            navigate("/Loan/LoanClosing/NOCLetter", {
                              state: loan,
                            })
                          }
                        >
                          View
                        </button>
                      </div>
                      )}
                      {loan.status === "requested" && (
                        <span style={{ color: "orange", fontWeight: "bold" }}>
                          {loan.status}
                        </span>
                      )}     
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9">No closed loans found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="loanCloserReport-pagination">
          <button
            onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
            disabled={currentPage === 1}
          >
            Prev
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </section>
    </div>
  );
};

export default LoanCloserReport;
